import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { DeviceTypeResponse } from '@/types/apps/device-type.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface DeviceTypeGraphQLServiceInterface {}

type DeviceTypeGraphQLListResponse = GqlListResponse<DeviceTypeResponse>;

export class DeviceTypeGraphQLService
    extends BaseService
    implements DeviceTypeGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'deviceType';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            imageFileName: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,

            // devices: {
            //     customer: {
            //         id: true,
            //         name: true,
            //         email: true,
            //     },
            //     id: true,
            //     name: true,
            // },
        };
    }

    public async index(query: string): Promise<DeviceTypeGraphQLListResponse> {
        return this.fetchGqlList<DeviceTypeGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('deviceType', {
            userId: this.getQueryById(),
        });
    }
}
